module.exports = __webpack_public_path__ + "static/media/Sharp Hardhat (1).e7f3e5c0.jpg";